var _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrance7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.57,
    height: 38.25,
    viewBox: "0 0 39.57 38.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6.44 3.98 0 23.11 13.34 38.25 24.51 17.96 6.44 3.98",
    fill: "#fad2e1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "39.57 15.14 33.12 34.27 13.34 38.25 19.78 19.12 26.45 10.88 39.57 15.14",
    fill: "#fbdfea"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.78 19.12 39.57 15.14 26.23 0 6.44 3.98 19.78 19.12",
    fill: "#fdedf3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance7);
export default __webpack_public_path__ + "static/media/entrance_7.21def655b15f072653eb81f4cc021d42.svg";
export { ForwardRef as ReactComponent };